'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _ = require('../../');

var _DefaultString = require('../../../helpers/DefaultString');

var _Popup = require('../../../helpers/Popup');

var _popup = require('../../../redux/modules/popup');

var _UnknownError = require('./UnknownError.scss');

var _UnknownError2 = _interopRequireDefault(_UnknownError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnknownError = (_dec = (0, _reactRedux.connect)(function (state) {
  return { auth: state.auth, type: state.popup.type };
}, { closePopup: _popup.closePopup }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(UnknownError, _Component);

  function UnknownError() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, UnknownError);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = UnknownError.__proto__ || (0, _getPrototypeOf2.default)(UnknownError)).call.apply(_ref, [this].concat(args))), _this), _this.closePopup = function () {
      _this.props.closePopup();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(UnknownError, [{
    key: 'render',
    value: function render() {
      var buttonTheme = _Popup.Popup.buttonTheme(this.props.auth.productName);
      return _react2.default.createElement(
        'div',
        { className: _UnknownError2.default.content },
        _react2.default.createElement(
          'div',
          { className: _UnknownError2.default.message },
          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.UnknownError)
        ),
        _react2.default.createElement(_.BaseButton, { onClick: this.closePopup, buttonString: _DefaultString.translations.Ok, className: _UnknownError2.default.okButton, theme: buttonTheme })
      );
    }
  }]);
  return UnknownError;
}(_react.Component), _class2.propTypes = {
  auth: _react.PropTypes.object,
  closePopup: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = UnknownError;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Popup/UnknownError/UnknownError.js
// module id = 1980
// module chunks = 0